<template>
  <download-excel :data="data" :fields="fields" :name="filename" type="xls">
    <v-btn  
      v-bind="exportBtnProps"
      @click="exportExcel"
      :disabled="!data || data.length == 0"
    >
      {{ $t("Export") }}
      <v-icon color="secondary" class="mx-1"> mdi-file-excel </v-icon>
    </v-btn>
  </download-excel>
</template>
<script>
import JsonExcel from "vue-json-excel";
export default {
  name: "ExportJsonExcel",
  components: {
    DownloadExcel: JsonExcel
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    filename: {
      type: String,
      default: "export"
    },
    fields: {
      type: Array,
      required: true
    },
    exportBtnProps: {
      type: Object
    }
  },
  methods: {
    exportExcel() {
      const jsonExcel = new JsonExcel();
      jsonExcel.exportJsonToExcel(this.data, this.filename, this.fields);
    }
  }
};
</script>
